import React from "react";
import PropTypes from "prop-types";
import Address from "./address";
import StyledSelect from "./styledSelect";

class Offices extends React.Component {
    constructor(props) {
        super(props);
        this.offices = props.offices;
        this.setCurrentOffice = this.props.setCurrentOffice;
        this.state = { currentOfficeId: this.offices[0].id };
    }

    getOptions(){
        return this.offices.map((x) => {
            return { label: `${x.name} [${ Math.round(x.distance) }mi]`, value: x.id };
        });
    }

    getCurrentOffice(officeId = this.state.currentOfficeId){
        return this.offices.find((x)=>{
            return x.id === officeId;
        });
    }

    onChange(values){
        const officeId = values[0].value;
        this.setState({currentOfficeId: officeId});
        this.setCurrentOffice(this.getCurrentOffice(officeId));
    }

    render() {
        return (
            <div className="offices">
                <StyledSelect
                    searchable={false}
                    options={this.getOptions()}
                    values={[{ label: `${this.getCurrentOffice().name} [${Math.round(this.getCurrentOffice().distance)}mi]`, value: this.getCurrentOffice().id }]}
                    onChange={(values) => this.onChange(values)}
                />

                <Address
                    address={this.getCurrentOffice().address}
                    lng={this.getCurrentOffice().coordinates.lng}
                    lat={this.getCurrentOffice().coordinates.lat}
                />
            </div>
        )
    }
}

Offices.propTypes = {
    offices: PropTypes.arrayOf(PropTypes.shape({
        id: PropTypes.number.isRequired,
        name: PropTypes.string.isRequired,
        address: PropTypes.string.isRequired,
        distance: PropTypes.number.isRequired,
        coordinates: PropTypes.shape({
            lat: PropTypes.number.isRequired,
            lng: PropTypes.number.isRequired
        })
    })).isRequired,
    setCurrentOffice: PropTypes.func.isRequired
};

export default Offices;
